import HttpRequest from './http_request'
// import Router from '@/router';

class AuthProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_API_URL)
  }

  async createAccount(user) {
    const { data } = await this.create('/', {
      function: 'create-user-account',
      CREATE_USER_ACCOUNT_AS_INTER: user.CREATE_USER_ACCOUNT_AS_INTER,
      EMAIL: user.EMAIL,
      CITIZEN_ID: user.CITIZEN_ID,
      PASSPORT_ID: user.PASSPORT_ID,
    })
    return data
  }
  async login(user) {
    const { data } = await this.post('/', {
      function: 'login',
      username: user.username,
      password: user.password,
    })
    return data
  }
  async logout() {
    await this.post('/', {
      function: 'logout',
    })
    window.location.reload();
  }
  async getUserInfo(uid) {
    const { data } = await this.get('/', {
      function: 'get-user-info',
      UID: uid,
    })
    return data
  }
  async requestPassword({ CITIZEN_ID }) {
    const { data } = await this.post('/', {
      function: 'request-password',
      CITIZEN_ID,
    })
    return data
  }
  async checkSecureKey({ SECURE_KEY }) {
    const { data } = await this.post('/', {
      function: 'check-password',
      SECURE_KEY,
    })
    return data
  }
  async setPassword({ SECURE_KEY, PASSWORD }) {
    const { data } = await this.post('/', {
      function: 'set-password',
      SECURE_KEY,
      PASSWORD,
    })
    return data
  }
  async getSidebarStatus(uid) {
    const { data } = await this.get('/', {
      function: 'get-sidebar-status',
      UID: uid,
    })
    return data
  }
}

export default AuthProvider